import { config } from "zod";
import { en } from "zod/locales";

config(en());

export * from "zod";
